import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { Header } from 'semantic-ui-react';
import { groupItems, getOrderedGroups, createContainerClassName, shouldDisplayHeader, shouldDisplayDescription } from './GroupedList.utils';
import MarkdownContent from '../../../../components/MarkdownContent/MarkdownContent';
import { ObjectPropsPropType } from '../../../../services/proptypes';
import { createComponent } from '../../services/components';
var defaultProps = {
  itemComponent: /*#__PURE__*/React.createElement("div", null),
  groupHeaderComponent: /*#__PURE__*/React.createElement(Header, {
    as: "h2"
  }),
  groupDescriptionComponent: /*#__PURE__*/React.createElement(MarkdownContent, {
    className: "group-description"
  }),
  groupDescriptionKey: '',
  groupContainerComponent: /*#__PURE__*/React.createElement("div", {
    className: "group-items"
  }),
  groupOrderOptions: {
    order: [],
    orderKey: '',
    defaultGroupPosition: 'end'
  },
  defaultGroupName: null,
  displayDefaultGroupName: false,
  className: ''
};
export default function GroupedList(_ref) {
  var items = _ref.items,
    groupBy = _ref.groupBy,
    childItemsKey = _ref.childItemsKey,
    itemComponent = _ref.itemComponent,
    groupHeaderComponent = _ref.groupHeaderComponent,
    groupDescriptionComponent = _ref.groupDescriptionComponent,
    groupDescriptionKey = _ref.groupDescriptionKey,
    groupContainerComponent = _ref.groupContainerComponent,
    groupOrderOptions = _ref.groupOrderOptions,
    defaultGroupName = _ref.defaultGroupName,
    displayDefaultGroupName = _ref.displayDefaultGroupName,
    className = _ref.className;
  var groupedItems = groupItems(items, groupBy, defaultGroupName, groupDescriptionKey);
  return /*#__PURE__*/React.createElement("div", {
    className: createContainerClassName(className)
  }, getOrderedGroups(groupedItems, defaultGroupName, groupOrderOptions).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 3),
      groupName = _ref3[0],
      groupDescription = _ref3[1],
      groupValue = _ref3[2];
    return /*#__PURE__*/React.createElement("div", {
      key: groupName,
      className: "group"
    }, shouldDisplayHeader(groupName, defaultGroupName, displayDefaultGroupName) && createComponent(groupHeaderComponent, {
      children: groupName
    }), shouldDisplayDescription(groupName, defaultGroupName, groupDescriptionKey) && createComponent(groupDescriptionComponent, {
      children: groupDescription
    }), createComponent(groupContainerComponent, {
      children: groupValue.map(function (groupValues) {
        return createComponent(itemComponent, _defineProperty({}, childItemsKey, groupValues));
      })
    }));
  }));
}
GroupedList.defaultProps = defaultProps;